module.exports = __webpack_public_path__ + "img/9788937454554.fe62e469.jpg";